import tmhRequest from '@/config/tmhRequest'

export default {

    searchListProductClassify: function (data) {
        return tmhRequest({
            url: '/project/tmh/productclassify/searchlistproductclassify',
            method: 'post',
            params: data,
        })
    },

    searchProductClassifyTree: function (data) {
        return tmhRequest({
            url: '/project/tmh/productclassify/searchproductclassifytree',
            method: 'post',
            params: data,
        })
    },

    addProductClassify: function (data) {
        return tmhRequest({
            url: '/project/tmh/productclassify/addproductclassify',
            method: 'post',
            params: data,
        })
    },

    editProductClassify: function (data) {
        return tmhRequest({
            url: '/project/tmh/productclassify/editproductclassify',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/item/productclassify.js